import React, { useRef, useMemo } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api'
import { useTheme } from '@material-ui/core'
import { styled } from '~/libraries/styled'
import { roadMapStyles } from '~/legacy/components/Map/GoogleMaps/style'

const defaultPosition = {
  lat: 42.3601,
  lng: -71.0589,
}

export const MapInput = (props) => {
  const theme = useTheme()
  const map = useRef(null)

  const customIcon = useMemo(() => {
    const svg = getIconSvg({
      fill: theme.palette?.mapPins?.fill,
      stroke: theme.palette?.mapPins?.stroke,
    })

    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
      scaledSize: new window.google.maps.Size(33, 40),
      anchor: new window.google.maps.Point(16, 40), // Anchor at bottom center of pin
    }
  }, [theme.palette?.mapPins])

  return (
    <Container className={props.className}>
      <GoogleMap
        center={props.center ?? defaultPosition}
        zoom={props.zoom ?? 17}
        mapContainerStyle={{
          height: '100%',
          width: '100%',
        }}
        options={{
          fullscreenControl: false,
          streetViewControl: false,
          styles: roadMapStyles,
          ...props.options,
        }}
        onLoad={(value) => {
          map.current = value
        }}
      >
        <Marker
          position={props.center ?? defaultPosition}
          draggable
          icon={customIcon}
          onDragEnd={(event) => {
            const position = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            }
            props.onChange?.(position)
          }}
        />
      </GoogleMap>
    </Container>
  )
}

// Create a custom icon using existing MapMarkerIcon2 SVG
function getIconSvg({ fill, stroke }) {
  return `
      <svg width="33px" height="40px" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1779_3638)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.1743 12C28.1743 5.37258 22.7627 0 16.0872 0C9.41161 0 4 5.37258 4 12C4 21.6 12.0581 29.3333 16.0872 32C20.1162 29.3333 28.1743 21.6 28.1743 12Z"
            fill="${fill || '#4285f4'}"
            stroke="${stroke || '#ffffff'}"
          />
          <ellipse cx="16.0876" cy="12" rx="4.02906" ry="4" fill="white" />
        </g>
        <defs>
          <filter
            id="filter0_d_1779_3638"
            x="0"
            y="0"
            width="32.1758"
            height="40"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1779_3638"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1779_3638"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    `
}

const Container = styled('div', {
  position: 'relative',
  border: '1px solid #E0E0E0',
  borderRadius: '4px',
  height: '400px',
  overflow: 'hidden',
})
